/* @flow */
import cx from 'classnames';
import React from 'react';
import ManagerItemCard from './ManagerItemCard.jsx';
import Text from 'components/Text.jsx';
import Image from 'components/Image.jsx';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import BankAccountsMenuButton from './BankAccountsMenuButton.jsx';
import ExternalAccountResource from 'entities/ExternalAccountResource';

import './styles/SchoolBankAccountsManagerItem.scss';
import './styles/BankAccountsManagerItem.scss';

export default class SchoolBankAccountsManagerItem extends React.Component {
  static propTypes = {
    externalAccount: React.PropTypes.instanceOf(ExternalAccountResource).isRequired,
  }

  renderPrimary() {
    return (
      <div className="BankAccountsManagerItem-primary">
        Primary account
      </div>
    );
  }

  render() {
    const { externalAccount } = this.props;
    const externalBankAccount = externalAccount.getBankAccount();
    const connectedBankAccount = externalAccount.getConnectedAccount();
    const organizationName = connectedBankAccount.getOrganizationName();

    const displayName = organizationName ?
      `${organizationName} account` :
      connectedBankAccount.getOwnerName();

    return (
      <ManagerItemCard className={cx('SchoolBankAccountsManagerItem', this.props.className)}>
        <FlexibleBlock flex="left">
          <div>
            <Image
              className="SchoolBankAccountsManagerItem-image"
              src={require('assets/images/payments/school-bank-account.svg')}
            />
            <div className="SchoolBankAccountsManagerItem-content">
              <div className="SchoolBankAccountsManagerItem-title">
                <Text size="large">
                  {displayName}
                </Text>
              </div>
              <div>
                <div>
                  <Text
                    size="xsmall"
                    className="SchoolBankAccountsManagerItem-label"
                    color="thunder">
                    Account admin name:
                  </Text>
                  <Text size="xsmall" color="thunder">
                    {connectedBankAccount.getOwnerName()}
                  </Text>
                </div>
                <div>
                  <Text
                    size="xsmall"
                    className="SchoolBankAccountsManagerItem-label"
                    color="thunder">
                    Account admin email:
                  </Text>
                  <Text size="xsmall" color="thunder">
                    {connectedBankAccount.getOwnerAddress()}
                  </Text>
                </div>
              </div>
            </div>
          </div>
          <div>
            {externalBankAccount.isDefaultForCurrency() && this.renderPrimary()}
            {
              !externalBankAccount.isDefaultForCurrency() &&
                <BankAccountsMenuButton bankAccount={externalAccount} />
            }
          </div>
        </FlexibleBlock>
      </ManagerItemCard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/SchoolBankAccountsManagerItem.jsx